import React, { useEffect, useCallback, useState } from 'react';
import { LoginPageStyled } from './login.page.styled';
import Form from '../../../components/shared/form/form';
import LoginForm from './components/login-form/login-form';
// import Button from '../../../components/base/button/button';
// import { ButtonVariant } from '../../../components/base/button/constants';
import ClickableText from '../../../components/base/clickable-text/clickable-text';
import { ValidationLoginSchema } from './components/login-form/constants';
import i18n from '../../../translations/strings';
import { useDispatch, useSelector } from 'react-redux';
import {
  loginAction,
  // loginErrorAction,
  loginResetState,
  // loginSocialAction,
} from '../../../store/auth/login.store';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../../../components/shared/modal-provider/components/modal/modal.constants';
import LinearLoading from '../../../components/base/loading/linear-loading/linear-loading';
// import {
//   IResolveParams,
//   LoginSocialFacebook,
//   LoginSocialGoogle,
// } from 'reactjs-social-login';
// import { userSetDataAction } from '../../../store/user.store';

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openModal } = useModal();

  const [userData, setUserData] = useState<any>(null);

  const {
    loginSuccess,
    loading,
    error,
    navigationPage,
    // goToSocialRegistration,
  } = useSelector((state: any) => {
    return state.login;
  });

  const handleCloseModal = () => {
    dispatch(loginResetState());
  };

  const onSubmit = (data: any) => {
    dispatch(loginAction(data));
  };

  useEffect(() => {
    if (loginSuccess) {
      dispatch(loginResetState());
      navigate(navigationPage, { replace: true });
    }
  }, [loginSuccess, navigationPage]);

  useEffect(() => {
    openModal({
      message: error,
      variant: ModalVariant.Error,
      handleCloseModal: handleCloseModal,
    });
  }, [error]);

  // useEffect(() => {
  //   if (goToSocialRegistration) {
  //     dispatch(loginResetState());
  //     dispatch(userSetDataAction(userData));
  //     navigate('/registration-customer', {
  //       state: {
  //         isSocialRegistration: true,
  //         provider: userData.provider,
  //         isBookingFromLandingPage: false,
  //       },
  //     });
  //   }
  // }, [goToSocialRegistration]);

  // const onLoginStart = useCallback(() => {
  //   dispatch(loginSocialAction(true));
  // }, []);

  // const onSocialLogin = useCallback((provider: any, data: any) => {
  //   if (provider === 'facebook') {
  //     setUserData({
  //       email: data.email,
  //       first_name: data.first_name,
  //       last_name: data.last_name,
  //       access_token: data.accessToken,
  //       facebook_id: data.id,
  //       provider: provider,
  //     });
  //   } else if (provider === 'google') {
  //     setUserData({
  //       email: data.email,
  //       first_name: data.given_name,
  //       last_name: data.family_name,
  //       access_token: data.access_token,
  //       google_id: data.sub,
  //       provider: provider,
  //     });
  //   }

  //   let dataToSend;

  //   if (provider === 'facebook') {
  //     dataToSend = {
  //       facebook_id: data.id,
  //       access_token: data.accessToken,
  //     };
  //   } else if (provider === 'google') {
  //     dataToSend = {
  //       access_token: data.access_token,
  //       google_id: data.sub,
  //     };
  //   }
  //   dispatch(loginAction({ dataToSend, isSocialLogin: true }));
  // }, []);

  return (
    <LoginPageStyled.Container container>
      <LinearLoading loading={loading} />
      <LoginPageStyled.ItemGrid item xs={12} md={4}>
        <LoginPageStyled.Title>
          {i18n.t('login.loginIntoYourAccount')}
        </LoginPageStyled.Title>
        <LoginPageStyled.Separator />
        <Form schema={ValidationLoginSchema}>
          <LoginForm onSubmit={onSubmit} loading={loading} />
        </Form>
        {/* <LoginPageStyled.SocialText>
          {i18n.t('login.loginWithSocial')}
        </LoginPageStyled.SocialText> */}
        {/* <LoginPageStyled.Separator />
        <LoginPageStyled.ContainerButtonsSocial>
          <LoginSocialGoogle
            client_id={process.env.REACT_APP_CLIENT_ID_GOOGLE || ''}
            onLoginStart={onLoginStart}
            redirect_uri={process.env.REACT_APP_REDIRECT_URI}
            scope="openid profile email"
            discoveryDocs="claims_supported"
            access_type="offline"
            onResolve={({ provider, data }: IResolveParams) => {
              onSocialLogin(provider, data);
            }}
            onReject={err => {
              dispatch(loginErrorAction(i18n.t('apiError.error_generic')));
            }}
          >
            <Button
              onClick={() => null}
              label={i18n.t('login.loginWithGoogle')}
              variant={ButtonVariant.Google}
            />
          </LoginSocialGoogle>
        </LoginPageStyled.ContainerButtonsSocial>
        <LoginPageStyled.Separator />
        <LoginPageStyled.ContainerButtonsSocial>
          <LoginSocialFacebook
            appId={process.env.REACT_APP_APP_ID_FACEBOOK || ''}
            fieldsProfile={
              'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
            }
            onLoginStart={onLoginStart}
            redirect_uri={process.env.REACT_APP_REDIRECT_URI}
            onResolve={({ provider, data }: IResolveParams) => {
              onSocialLogin(provider, data);
            }}
            onReject={err => {
              dispatch(loginErrorAction(i18n.t('apiError.error_generic')));
            }}
          >
            <Button
              onClick={() => null}
              label={i18n.t('login.loginWithFacebook')}
              variant={ButtonVariant.Facebook}
            />
          </LoginSocialFacebook>
        </LoginPageStyled.ContainerButtonsSocial>
        <LoginPageStyled.Separator /> */}
        <ClickableText
          text={i18n.t('login.notSignUp')}
          clickableText={i18n.t('login.signUp')}
          href={'/registration-customer'}
        />
        <LoginPageStyled.Separator />
        <ClickableText
          text={i18n.t('login.forgotPassword')}
          clickableText={i18n.t('login.forgotPasswordClick')}
          href={'/reset-password'}
        />
      </LoginPageStyled.ItemGrid>
    </LoginPageStyled.Container>
  );
};

export default LoginPage;
